var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getMessage from 'src/background/utils/i18n.utils';
import React from 'react';
import ButtonComponent from 'src/common-ui/button/button.component';
import { SVGIcons } from 'src/common-ui/icons.enum';
import { SVGIcon } from 'src/common-ui/svg-icon/svg-icon.component';
export const ErrorFallback = ({ error, theme, chain }) => {
    const formattedErrorMessage = `
    \`\`\` 
    ${error.message} \n\r
    ${error.stack} \n\r
    \`\`\`
    `;
    const handleClickOnCopy = () => __awaiter(void 0, void 0, void 0, function* () {
        yield navigator.clipboard.writeText(formattedErrorMessage);
        window.open('https://discord.gg/sPgu3C5YKC', '_blank');
    });
    return (React.createElement("div", { className: "error-page" },
        React.createElement(SVGIcon, { icon: SVGIcons.MESSAGE_ERROR }),
        React.createElement("div", { className: "title" }, getMessage('error_message_title')),
        React.createElement("div", { className: "detail" },
            React.createElement("div", { className: "message" }, error.message.toString()),
            React.createElement("div", { className: "stack" }, error.stack.toString())),
        React.createElement(ButtonComponent, { onClick: () => handleClickOnCopy(), label: "html_popup_copy_error" })));
};
